import {createContext} from 'react';

const ModuleSettings = createContext({showCellName:"", doShowCell:false, upDateSettings:()=>{}});

export default ModuleSettings;